/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import home from './home'
import hrpe from './hrpe'
import airService from './air-service'
import { getPsnInfo } from '@/pages/air-service/apis/home'

const routeArr = [].concat(
  airService,
  home,
  hrpe
)
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routeArr
})
const getPsnInfoData = async (toName) => {
  try {
    // 定义不需要强制登录的路由页面
    let NoLoginRequiredRouterName = [
      'Login',
      'qwLogin',
      'authLogin',
      'SsoLogin',
      'SpaceGXSsoLogin',
      'SpaceSsoLogin',
      'SpaceleyaLogin',
      'air-service-employee-customerinfoform',
      'air-service-employee-information-acquisition',
      'air-service-employee-information-acquisition-login',
      'air-service-employee-information-acquisition-excel'
    ]
    if (NoLoginRequiredRouterName.includes(toName)) return
    // 获取人员信息
    let userInfoData = JSON.parse(sessionStorage.getItem('userInfoData'))
    if (!userInfoData) {
      const userInfo = await getPsnInfo()
      sessionStorage.setItem('userInfoData', JSON.stringify(userInfo.data[0]))
      userInfoData = userInfo.data[0]
    }
    return userInfoData
  } catch (error) {
  }
}

router.beforeEach(async (to, from, next) => {
  // 寰图集团的集团主键、荟育集团主键 跳转旧系统页面
  let groupArr = ['00016A100000003PPG58', '00016A100000003Z21CJ', '00016A100000004NYNTF']
  // !!to.name 防止单点登录请求报错
  const userInfoData = !!to.name && await getPsnInfoData(to.name)
  let isInGroupArr = userInfoData && groupArr.includes(userInfoData.pk_group)
  document.title = isInGroupArr ? '人力资源自助' : '人力资源自助'
  // 登录跳转处理
  if (to.name === 'Home') { // 不同集团跳转到首页的处理
    if (isInGroupArr) {
      next()
    } else {
      next({name: 'air-service-employee-home'})
    }
  } else if (to.meta && to.meta.belong === 'air-service') { // 防止寰图集团、荟育集团 进入新空服
    if (isInGroupArr) {
      next({name: from.name})
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js